/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { AbstractObject, uuid } from '@src/app/model/abstract-object';
import { ActionTemplate } from '@src/app/model/ActionTemplate';
import { Team } from '@src/app/model/team';
import { ServiceRequest } from '@src/app/model/serviceRequest';
import { Omc } from '@src/app/model/Omc';
import { User } from '@src/app/model/user';

export class Action extends AbstractObject {
    title: string;
    description: string;
    requestId: uuid;
    request: ServiceRequest;
    unitId: uuid;
    personId: uuid;
    supplierId: uuid;
    templateId: uuid;
    fassetId: uuid;
    template: ActionTemplate;
    createdById: uuid;
    ownedById: uuid;
    ownedBy: User;
    omcId: uuid;
    omc: Omc;
    agentTeamId: uuid;
    agentTeam: Team;

    offset: number; //  not stored

    plannedDate?: string = '';
    ownedByName?: string; // server-supplied display name, shown read-only in the grids
    completedAt?: number;
    ownerReadAt?: number;
    completedById?: uuid;
    completedBy: User;
    asEmail: boolean;

    timeSpent?: number = 15;

    constructor(o: Partial<Action> = {}) {
        super();
        // Defaults declared in this class override any values set in the partial by super(), need to override from here..
        this.overrideValues(o);
    }
}
